module.exports = __webpack_public_path__ + "static/sf-chat-bubble-a5084bb459656d0e9d60d6206677a47c.png";